export default __webpack_public_path__ + "static/media/feature-tile-icon-05.af2bae11.svg";